import axios from "axios";
// import { getToken } from "@/util/auth";
import { cacheAdapterEnhancer } from "axios-extensions";
import { Cache } from "axios-extensions";

const cacheObj = new Cache({
  maxAge: 1000 * 60 * 6, // 6 分钟
  max: 600
});

// 创建axios实例
const service = axios.create({
  baseURL: window.__config.VUE_APP_BASE_API,
  withCredentials: false, // send cookies when cross-domain requests
  timeout: 55000, // request timeout
  adapter: cacheAdapterEnhancer(axios.defaults.adapter, {
    enabledByDefault: true,
    defaultCache: cacheObj // 重写defaultCache对象，所有请求有效
  })
});

// request拦截器
service.interceptors.request.use(
  config => {
    // if (getToken()) {
    //   config.headers["Authorization"] = "Bearer " + getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    // }
    // config.headers['Content-Type'] = 'application/json'
    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    if (response.status === 200) {
      const res = response.data;
      return res;
    } else {
      return Promise.reject(response.statusText);
    }
  },
  error => {
    console.log(error);
    return Promise.reject(error);
  }
);

export default service;
